import React, { useState } from 'react';

export function NoPhoto() {
  return (
    <div className="bg-body-secondary rounded" style={{ width: '100%', paddingBottom: '100%', position: 'relative' }}>
      <svg
        width="76"
        height="76"
        viewBox="0 0 76 76"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{
          position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
        }}
      >
        <g opacity="0.5">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M53.5562 50.7277C54.7572 50.3359 55.625 49.2068 55.625 47.875V30.5C55.625 28.8431 54.2819 27.5 52.625 27.5H48.118L46.2958 23.8556C45.957 23.178 45.2645 22.75 44.507 22.75H31.493C30.7355 22.75 30.043 23.178 29.7042 23.8556L28.6975 25.869L30.1882 27.3597L31.493 24.75L44.507 24.75L46.6056 28.9472C46.775 29.286 47.1212 29.5 47.5 29.5H52.625C53.1773 29.5 53.625 29.9477 53.625 30.5V47.875C53.625 48.4273 53.1773 48.875 52.625 48.875H51.7035L53.5562 50.7277ZM43.2273 40.3988C43.5629 39.6687 43.75 38.8562 43.75 38C43.75 34.8244 41.1756 32.25 38 32.25C37.1438 32.25 36.3313 32.4371 35.6012 32.7727L37.1705 34.342C37.4374 34.2818 37.715 34.25 38 34.25C40.0711 34.25 41.75 35.9289 41.75 38C41.75 38.285 41.7182 38.5626 41.658 38.8295L43.2273 40.3988ZM38.8296 41.6579L40.3989 43.2272C39.6687 43.5629 38.8562 43.75 38 43.75C34.8244 43.75 32.25 41.1756 32.25 38C32.25 37.1438 32.4371 36.3313 32.7728 35.6011L34.3421 37.1704C34.2818 37.4373 34.25 37.7149 34.25 38C34.25 40.0711 35.9289 41.75 38 41.75C38.2851 41.75 38.5627 41.7182 38.8296 41.6579ZM26.6716 29.5H23.375C22.8227 29.5 22.375 29.9477 22.375 30.5V47.875C22.375 48.4273 22.8227 48.875 23.375 48.875H46.0466L48.0466 50.875H23.375C21.7181 50.875 20.375 49.5319 20.375 47.875V30.5C20.375 28.8431 21.7181 27.5 23.375 27.5H24.6716L26.6716 29.5Z"
            fill="#D6DADF"
          />
          <path d="M23.75 23.75L52.25 52.25" stroke="#D6DADF" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
        </g>
      </svg>
    </div>
  );
}

export function Cart() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.75 7.25H7.625L8 8.75M15.5 14H10.8741C9.95632 14 9.15635 13.3754 8.93377 12.4851L8.75 11.75M8.75 11.75H16.25L17 8.75H8M8.75 11.75L8 8.75"
        className="stroke-primary"
        stroke="#0d6efd"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="9.875" cy="16.625" r="0.625" fill="#0d6efd" stroke="#0d6efd" className="stroke-primary" />
      <circle cx="15.125" cy="16.625" r="0.625" fill="#0d6efd" stroke="#0d6efd" className="stroke-primary" />
    </svg>
  );
}

export function ArrowRight() {
  return (
    <svg className="ms-1" width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.5 1.5L6 6L1.5 10.5"
        className="stroke-btn-font"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function ArrowLeft() {
  return (
    <svg className="me-2" width="7" height="18" viewBox="0 0 7 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        className="stroke-primary"
        d="M7 1L1 7L7 13"
        stroke="#0A56C5"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SearchTextColor({ size = 30 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.125 6.80001C10.8744 6.80001 9.05 8.62445 9.05 10.875C9.05 12.0005 9.50523 13.0182 10.2435 13.7565C10.9818 14.4948 11.9995 14.95 13.125 14.95C15.3756 14.95 17.2 13.1256 17.2 10.875C17.2 8.62445 15.3756 6.80001 13.125 6.80001ZM7.45 10.875C7.45 7.7408 9.99078 5.20001 13.125 5.20001C16.2592 5.20001 18.8 7.7408 18.8 10.875C18.8 14.0092 16.2592 16.55 13.125 16.55C11.8467 16.55 10.6663 16.1267 9.71774 15.4136L6.56568 18.5657C6.25326 18.8781 5.74673 18.8781 5.43431 18.5657C5.12189 18.2533 5.12189 17.7467 5.43431 17.4343L8.58637 14.2823C7.87332 13.3337 7.45 12.1533 7.45 10.875Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function Minus() {
  return (
    <svg
      className="d-inline-block align-middle"
      width="16"
      height="16"
      viewBox="0 0 16 2"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        className="fill-primary-darken"
        d="M16 1C16 1.55228 15.5523 2 15 2L1 2C0.447715 2 -2.41411e-08 1.55228 0 0.999999C2.41411e-08 0.447715 0.447715 -6.36101e-07 1 -6.11959e-07L15 0C15.5523 2.41411e-08 16 0.447715 16 1Z"
        fill="white"
      />
    </svg>
  );
}

export function Plus() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        className="fill-btn-font"
        d="M9 1C9 0.447715 8.55229 0 8 0C7.44772 0 7 0.447715 7 1V7H1C0.447715 7 0 7.44771 0 8C0 8.55228 0.447715 9 1 9H7V15C7 15.5523 7.44772 16 8 16C8.55229 16 9 15.5523 9 15V9H15C15.5523 9 16 8.55229 16 8C16 7.44772 15.5523 7 15 7H9V1Z"
        fill="white"
      />
    </svg>
  );
}

export function TwitterIcon() {
  return (
    <svg fill="none" height="32" viewBox="0 0 32 32" width="32" xmlns="http://www.w3.org/2000/svg">
      <filter
        id="a"
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
        height="52"
        width="52"
        x="-10"
        y="-7"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
        <feOffset dy="3" />
        <feGaussianBlur stdDeviation="5" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
        <feBlend in2="BackgroundImageFix" mode="normal" result="effect1_dropShadow" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow" mode="normal" result="shape" />
      </filter>
      <clipPath id="b">
        <path d="m0 0h32v32h-32z" />
      </clipPath>
      <clipPath id="c">
        <path d="m5.9259 5.92593h20.1481v20.1481h-20.1481z" />
      </clipPath>
      <g clipPath="url(#b)">
        <g filter="url(#a)">
          <g clipPath="url(#c)">
            <path
              d="m12.2643 24.1852c7.6012 0 11.7599-6.299 11.7599-11.7599 0-.1771-.0039-.3581-.0118-.5352.809-.585 1.5072-1.3097 2.0617-2.13993-.7535.33523-1.5534.55413-2.3726.64933.8625-.51702 1.5083-1.32919 1.8177-2.28598-.8114.48086-1.6987.82007-2.624 1.00308-.6234-.66241-1.4477-1.10101-2.3454-1.24797-.8976-.14697-1.8187.00587-2.6209.4349-.8021.42902-1.4405 1.11034-1.8166 1.93857-.376.8283-.4688 1.7574-.2638 2.6436-1.643-.0824-3.2503-.5092-4.7177-1.2527-1.46739-.7435-2.76219-1.78701-3.80043-3.063-.52769.9098-.68916 1.9864-.4516 3.011.23756 1.0245.85632 1.9202 1.73054 2.505-.65631-.0209-1.29824-.1976-1.87276-.5156v.0512c-.00059.9548.32948 1.8803.93411 2.6192.60462.7389 1.44648 1.2456 2.38244 1.434-.60794.1664-1.24603.1906-1.86486.0709.26412.8211.778 1.5392 1.46992 2.0542.69194.515 1.52734.8011 2.38974.8185-1.4641 1.15-3.27257 1.7737-5.13427 1.7708-.33015-.0005-.65998-.0207-.98773-.0606 1.89129 1.2134 4.0914 1.8578 6.3384 1.8566z"
              fill="#247cfe"
              className="fill-primary"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

export function InstagramIcon() {
  return (
    <svg fill="none" height="32" viewBox="0 0 32 32" width="32" xmlns="http://www.w3.org/2000/svg">
      <filter
        id="a"
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
        height="52"
        width="52"
        x="-10"
        y="-7"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
        <feOffset dy="3" />
        <feGaussianBlur stdDeviation="5" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
        <feBlend in2="BackgroundImageFix" mode="normal" result="effect1_dropShadow" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow" mode="normal" result="shape" />
      </filter>
      <clipPath id="b">
        <path d="m0 0h32v32h-32z" />
      </clipPath>
      <clipPath id="c">
        <path d="m5.9259 5.92593h20.1481v20.1481h-20.1481z" />
      </clipPath>
      <g clipPath="url(#b)">
        <g filter="url(#a)">
          <g clipPath="url(#c)" fill="#247cfe" className="fill-primary">
            <path
              d="m16 7.74005c2.6916 0 3.0104.01181 4.069.05903.9838.04329 1.515.20857 1.8692.3463.4683.18102.8067.40139 1.1569.75162.3542.35417.5706.68866.7516 1.1569.1378.3542.303.8894.3463 1.8693.0473 1.0625.0591 1.3812.0591 4.0689 0 2.6917-.0118 3.0105-.0591 4.069-.0433.9838-.2085 1.5151-.3463 1.8692-.181.4683-.4014.8067-.7516 1.157-.3542.3541-.6886.5706-1.1569.7516-.3542.1377-.8894.303-1.8692.3463-1.0625.0472-1.3813.059-4.069.059-2.6917 0-3.0104-.0118-4.069-.059-.9838-.0433-1.5151-.2086-1.8692-.3463-.4683-.181-.80673-.4014-1.15696-.7516-.35417-.3542-.5706-.6887-.75162-1.157-.13773-.3541-.30301-.8893-.3463-1.8692-.04722-1.0625-.05903-1.3812-.05903-4.069 0-2.6916.01181-3.0104.05903-4.0689.04329-.9838.20857-1.5151.3463-1.8693.18102-.46824.40139-.80667.75162-1.1569.35417-.35417.68866-.5706 1.15696-.75162.3541-.13773.8893-.30301 1.8692-.3463 1.0586-.04722 1.3773-.05903 4.069-.05903zm0-1.81412c-2.735 0-3.0773.01181-4.1516.05903-1.0704.04722-1.8063.22037-2.44379.46829-.66505.25972-1.22778.60208-1.78658 1.16481-.56273.5588-.90509 1.12153-1.16481 1.78264-.24792.6414-.42107 1.3734-.46829 2.4438-.04722 1.0782-.05903 1.4206-.05903 4.1555 0 2.735.01181 3.0773.05903 4.1516.04722 1.0704.22037 1.8063.46829 2.4438.25972.665.60208 1.2278 1.16481 1.7866.5588.5588 1.12153.905 1.78264 1.1608.64143.2479 1.37343.4211 2.44373.4683 1.0743.0472 1.4167.059 4.1516.059 2.735 0 3.0774-.0118 4.1517-.059 1.0703-.0472 1.8062-.2204 2.4437-.4683.6611-.2558 1.2239-.602 1.7827-1.1608.5587-.5588.905-1.1216 1.1608-1.7827.2479-.6414.4211-1.3734.4683-2.4437.0472-1.0743.059-1.4167.059-4.1517 0-2.7349-.0118-3.0773-.059-4.1516-.0472-1.0703-.2204-1.8062-.4683-2.44373-.2479-.66898-.5902-1.23171-1.153-1.79051-.5588-.55879-1.1215-.90509-1.7826-1.16088-.6415-.24791-1.3734-.42106-2.4438-.46828-1.0782-.05116-1.4206-.06297-4.1555-.06297z"
            />
            <path
              d="m16 10.8252c-2.857 0-5.1748 2.3178-5.1748 5.1748 0 2.8569 2.3178 5.1748 5.1748 5.1748 2.8569 0 5.1747-2.3179 5.1747-5.1748 0-2.857-2.3178-5.1748-5.1747-5.1748zm0 8.5315c-1.8535 0-3.3567-1.5032-3.3567-3.3567s1.5032-3.3567 3.3567-3.3567c1.8534 0 3.3567 1.5032 3.3567 3.3567s-1.5033 3.3567-3.3567 3.3567z"
            />
            <path
              d="m22.5875 10.6206c0 .669-.5431 1.2081-1.2081 1.2081-.669 0-1.2081-.5431-1.2081-1.2081 0-.669.543-1.20812 1.2081-1.20812.665 0 1.2081.54305 1.2081 1.20812z"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

export function FbIcon() {
  return (
    <svg
      fill="none"
      height="32"
      viewBox="0 0 32 32"
      width="32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <filter
        id="a"
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
        height="52"
        width="52"
        x="-10"
        y="-7"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
        <feOffset dy="3" />
        <feGaussianBlur stdDeviation="5" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
        <feBlend in2="BackgroundImageFix" mode="normal" result="effect1_dropShadow" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow" mode="normal" result="shape" />
      </filter>
      <clipPath id="b">
        <path d="m0 0h32v32h-32z" />
      </clipPath>
      <clipPath id="c">
        <path d="m5.9259 5.92593h20.1481v20.1481h-20.1481z" />
      </clipPath>
      <g clipPath="url(#b)">
        <g filter="url(#a)">
          <g clipPath="url(#c)">
            <path
              d="m26.0741 16c0-5.5638-4.5104-10.07407-10.0741-10.07407-5.5638 0-10.0741 4.51027-10.0741 10.07407 0 5.0282 3.68393 9.1959 8.5 9.9517v-7.0397h-2.5579v-2.912h2.5579v-2.2194c0-2.5249 1.504-3.91948 3.8051-3.91948 1.1019 0 2.2551.19678 2.2551.19678v2.4791h-1.2703c-1.2514 0-1.6417.7767-1.6417 1.5741v1.8889h2.7939l-.4466 2.912h-2.3473v7.0397c4.816-.7558 8.5-4.9235 8.5-9.9517z"
              fill="#247cfe"
              className="fill-primary"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

export function YouTubeIcon() {
  return (
    <svg
      fill="none"
      height="32"
      viewBox="0 0 32 32"
      width="32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <filter id="a" colorInterpolationFilters="sRGB" filterUnits="userSpaceOnUse" height="52" width="52" x="-10" y="-7">
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
        <feOffset dy="3" />
        <feGaussianBlur stdDeviation="5" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
        <feBlend in2="BackgroundImageFix" mode="normal" result="effect1_dropShadow" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow" mode="normal" result="shape" />
      </filter>
      <clipPath id="b">
        <path d="m0 0h32v32h-32z" />
      </clipPath>
      <clipPath id="c">
        <path d="m5.9259 5.92593h20.1481v20.1481h-20.1481z" />
      </clipPath>
      <g clipPath="url(#b)">
        <g filter="url(#a)">
          <g clipPath="url(#c)">
            <path
              d="m25.8734 11.9704s-.1968-1.3891-.8028-1.99905c-.7674-.80278-1.6253-.80672-2.0188-.85394-2.8176-.20463-7.0479-.20463-7.0479-.20463h-.0079s-4.2303 0-7.04787.20463c-.39352.04722-1.25139.05116-2.01875.85394-.60602.60995-.79885 1.99905-.79885 1.99905s-.20463 1.6331-.20463 3.2623v1.5268c0 1.6292.2007 3.2623.2007 3.2623s.19676 1.3891.79884 1.9991c.76736.8028 1.77477.7752 2.22338.8618 1.61338.1535 6.85118.2007 6.85118.2007s4.2342-.0079 7.0518-.2086c.3935-.0472 1.2514-.0511 2.0188-.8539.606-.61.8028-1.9991.8028-1.9991s.2007-1.6292.2007-3.2623v-1.5268c0-1.6292-.2007-3.2623-.2007-3.2623zm-11.9551 6.6426v-5.6627l5.4423 2.8412z"
              fill="#247cfe"
              className="fill-primary"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

export function VkIcon() {
  return (
    <svg fill="none" height="32" viewBox="0 0 32 32" width="32" xmlns="http://www.w3.org/2000/svg">
      <path
        clipRule="evenodd"
        d="m6.15396 8.77606c-.65396 1.28344-.65396 2.96364-.65396 6.32394v1.8c0 3.3603 0 5.0405.65396 6.3239.57524 1.129 1.49312 2.0469 2.6221 2.6221 1.28344.654 2.96364.654 6.32394.654h1.8c3.3603 0 5.0405 0 6.3239-.654 1.129-.5752 2.0469-1.4931 2.6221-2.6221.654-1.2834.654-2.9636.654-6.3239v-1.8c0-3.3603 0-5.0405-.654-6.32394-.5752-1.12898-1.4931-2.04686-2.6221-2.6221-1.2834-.65396-2.9636-.65396-6.3239-.65396h-1.8c-3.3603 0-5.0405 0-6.32394.65396-1.12898.57524-2.04686 1.49312-2.6221 2.6221zm14.92904 8.30854c-.0883.2248-.0521.4467.1095.666.206.2312.434.4665.6645.7042.682.7036 1.3854 1.4293 1.6032 2.1401.0767.4435-.2887.6086-.6597.6086l-1.9981.0328c-.1251.0274-.2707.0137-.437-.0411-.5759-.1894-.952-.6437-1.3314-1.1018-.2434-.294-.4881-.5895-.7878-.8177-.1494-.1137-.3296-.1913-.5034-.0988-.3926.2063-.4025.6032-.4126 1.0052-.0077.3038-.0154.6105-.1884.8401-.2285.2536-.6715.2214-1.033.1952-.1014-.0074-.1963-.0143-.2784-.0143-3.7387.1342-6.1763-5.2254-7.29021-7.9904-.13325-.3736.07685-.5591.45278-.5591l2.13873-.0163c.2285.0399.4455.1751.5307.411.3202.7833 1.486 3.609 2.2089 3.609s.542-2.8793.2965-3.4198c-.1301-.1863-.3511-.3042-.6634-.3534-.0676-.0109-.0546-.0767.0391-.1973.3278-.4219 2.3364-.5467 3.2159-.3371.1739.046.3438.1276.4215.3083.1759.4124.1355 1.1065.0946 1.8093-.0507.871-.1021 1.7552.2564 2.1326.1384.0362.2142.0404.3357-.0575.9235-.9313 1.5536-2.3803 2.0685-3.5677.0662-.1745.172-.2603.3355-.3001.2844 0 .5922.0013.9096.0026.6651.0027 1.3723.0057 1.9941-.0026.962 0-.43 1.9731-1.3683 3.3031-.3655.5182-.6622.9387-.724 1.1069z"
        fill="#2789f6"
        fillRule="evenodd"
        className="fill-primary"
      />
    </svg>
  );
}

export function SkypeIcon() {
  return (
    <svg fill="none" height="32" viewBox="0 0 32 32" width="32" xmlns="http://www.w3.org/2000/svg">
      <path
        clipRule="evenodd"
        d="m11.875 5.5c1.1559 0 2.2399.28952 3.1747.79572.3127-.03024.6297-.04572.9503-.04572 5.3848 0 9.75 4.3652 9.75 9.75 0 .481-.0348.9538-.1021 1.4162.541.9012.8521 1.9562.8521 3.0838 0 3.3137-2.6863 6-6 6-1.1276 0-2.1826-.3111-3.0838-.8521-.4624.0673-.9352.1021-1.4162.1021-5.3848 0-9.75-4.3652-9.75-9.75 0-.5048.03836-1.0006.11232-1.4847-.54827-.8859-.86232-1.9161-.86232-3.0153 0-3.31371 2.85418-6 6.375-6zm7.3467 7c.5283-1-1.5851-1.75-3.1701-1.75-1.5851 0-3.6985 1-3.6985 2.75s1.3209 2.375 2.6418 3c.2641.125.5613.2344.8585.3438.8916.3281 1.7832.6562 1.7832 1.4062 0 1-1.0567 1.25-2.1134 1.25-.3781 0-.8138-.1793-1.2453-.3569-.7741-.3186-1.5346-.6315-1.9248.1069-.5283 1 1.0403 2 3.1701 2 2.3776 0 4.2268-1 4.2268-3 0-1.8745-2.0886-2.651-3.4382-3.1527-.0903-.0336-.1774-.0659-.2602-.0973-1.3209-.5-1.5851-1-1.5851-1.5s.5284-1 1.5851-1c.3522 0 .7416.1519 1.131.3037.7788.3038 1.5576.6075 2.0391-.3037z"
        fill="#43a6ef"
        fillRule="evenodd"
        className="fill-primary"
      />
    </svg>
  );
}

export function GooglePlusIcon() {
  return (
    <svg className="fill-primary" role="img" width="34" height="34" viewBox="-5 -5 34 34" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.48 10.92v3.28h7.84c-.24 1.84-.853 3.187-1.787 4.133-1.147 1.147-2.933 2.4-6.053 2.4-4.827 0-8.6-3.893-8.6-8.72s3.773-8.72 8.6-8.72c2.6 0 4.507 1.027 5.907 2.347l2.307-2.307C18.747 1.44 16.133 0 12.48 0 5.867 0 .307 5.387.307 12s5.56 12 12.173 12c3.573 0 6.267-1.173 8.373-3.36 2.16-2.16 2.84-5.213 2.84-7.667 0-.76-.053-1.467-.173-2.053H12.48z"
      />
    </svg>
  );
}

export function TelegramIcon({ useCurrentColor }) {
  return (
    <svg fill="none" height="32" viewBox="0 0 32 32" width="32" xmlns="http://www.w3.org/2000/svg">
      <path
        clipRule="evenodd"
        d="m16 26.5c5.799 0 10.5-4.701 10.5-10.5s-4.701-10.5-10.5-10.5-10.5 4.701-10.5 10.5 4.701 10.5 10.5 10.5zm4.2219-15.6885c.5372-.2358 1.1115.241 1.018.8451l-1.3835 8.938c-.0841.5433-.6626.8266-1.1122.5446l-4.0087-2.5138c-.4178-.262-.4867-.8688-.1394-1.2269l3.5805-3.6915c.1281-.1322-.0354-.3454-.1854-.2418l-4.9741 3.4365c-.3677.2541-.8237.3234-1.2447.1893l-2.2063-.7026c-.3995-.1272-.42768-.7106-.04249-.8798z"
        fill="#2fb2f4"
        className="fill-primary"
        fillRule="evenodd"
      />
    </svg>
  );
}

export function OdnoklassnikiIcon() {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 5.5C10.201 5.5 5.5 10.201 5.5 16C5.5 21.799 10.201 26.5 16 26.5C21.799 26.5 26.5 21.799 26.5 16C26.5 10.201 21.799 5.5 16 5.5ZM15.9915 16.1927C17.8348 16.1927 19.3331 14.804 19.3331 13.0968C19.3331 11.3891 17.8348 10 15.9915 10C14.1487 10 12.6499 11.3891 12.6499 13.0968C12.6499 14.804 14.1487 16.1927 15.9915 16.1927ZM15.9915 11.8148C16.7545 11.8148 17.3751 12.3897 17.3751 13.0968C17.3751 13.8033 16.7545 14.3786 15.9915 14.3786C15.2291 14.3786 14.6079 13.8033 14.6079 13.0968C14.6079 12.3897 15.2291 11.8148 15.9915 11.8148ZM19.2925 17.9755C18.6883 18.3272 18.0323 18.5766 17.3521 18.7201L19.2201 20.4514C19.6028 20.8053 19.6028 21.38 19.2201 21.7343C18.8378 22.0886 18.2182 22.0886 17.8363 21.7343L15.9997 20.033L14.1646 21.7343C13.9732 21.9112 13.7225 21.9998 13.4718 21.9998C13.2215 21.9998 12.9711 21.9112 12.7798 21.7343C12.3975 21.38 12.3975 20.8057 12.7794 20.4514L14.6477 18.7201C13.9674 18.5766 13.3114 18.3268 12.7072 17.9755C12.2499 17.7083 12.1126 17.1486 12.4007 16.7245C12.688 16.2998 13.2922 16.172 13.7503 16.4391C15.1183 17.2366 16.8806 17.2368 18.2494 16.4391C18.7075 16.172 19.3115 16.2998 19.5994 16.7245C19.8875 17.1482 19.7498 17.7083 19.2925 17.9755Z"
        fill="#EE8208"
        className="fill-primary"
      />
    </svg>
  );
}

export function Phone() {
  return (
    <svg fill="none" height="32" viewBox="0 0 32 32" width="32" xmlns="http://www.w3.org/2000/svg">
      <path
        d="m24.8995 21.2426.5657.5656c.3124-.3124.3124-.8189 0-1.1313zm-14.1422-14.14218.5657-.56568c-.3124-.31242-.8189-.31242-1.1314 0zm3.5356 3.53558.64.48c.2388-.3185.2072-.7642-.0743-1.0457zm7.071 7.071.5657-.5657c-.2815-.2815-.7272-.3131-1.0457-.0743zm-2.8284 2.1213-.3578.7156c.2711.1355.5954.1063.8378-.0756zm-6.364-6.3639-.64-.48c-.1818.2424-.211.5667-.0755.8378zm-1.9799-5.79829 3.5356 3.53549 1.1314-1.1313-3.5356-3.53556zm15.2736 13.01079-3.5356-3.5356-1.1314 1.1314 3.5356 3.5355zm-4.5813-3.6099-2.8284 2.1213.96 1.28 2.8284-2.1213zm-7.231-6.911-2.1214 2.8284 1.28.96 2.1214-2.8284zm4.8826 9.6723c.3578-.7155.358-.7154.3582-.7153 0 0 .0002.0001.0004.0002l.0006.0003c.0004.0002.0007.0004.0009.0005.0004.0002.0005.0002.0003.0001-.0005-.0002-.0024-.0012-.0056-.0029-.0064-.0033-.0181-.0096-.035-.0188-.0339-.0186-.0884-.0493-.1623-.0937-.1478-.0886-.373-.2317-.6648-.4401-.5833-.4166-1.4335-1.0953-2.4625-2.1244l-1.1314 1.1314c1.0922 1.0923 2.0099 1.8278 2.6639 2.295.327.2336.5879.3999.7716.5101.0918.0551.1643.0962.2161.1246.0259.0142.0466.0252.062.0333.0077.004.014.0073.019.0098.0025.0013.0046.0024.0064.0033.001.0004.0018.0008.0025.0012.0004.0002.0007.0004.001.0005.0002.0001.0004.0002.0005.0003.0002.0001.0004.0002.3582-.7154zm-2.9698-3.3941c-1.0291-1.029-1.7078-1.8792-2.1244-2.4625-.2084-.2918-.3515-.517-.4401-.6648-.0444-.0739-.0751-.1284-.0937-.1623-.0093-.0169-.0155-.0286-.0188-.035-.0017-.0032-.0027-.0051-.0029-.0056-.0001-.0002-.0001-.0001.0001.0003.0001.0002.0003.0005.0005.0009.0001.0002.0002.0004.0003.0006s.0002.0004.0002.0004c.0001.0002.0002.0004-.7154.3582-.7155.3578-.7154.358-.7153.3582.0001.0001.0002.0003.0003.0005.0001.0003.0003.0006.0005.001.0003.0007.0008.0015.0012.0024.0009.0019.002.004.0033.0065.0025.005.0058.0113.0098.019.0081.0154.0191.0361.0333.062.0284.0518.0695.1243.1246.2161.1102.1837.2765.4446.5101.7715.4672.6541 1.2027 1.5718 2.295 2.664zm-2.8285 2.8285c-2.82558-2.8257-4.03985-4.7675-4.18836-6.4011-.14235-1.5658.68304-3.10435 2.77416-5.19549l-1.1314-1.13137c-2.15145 2.1515-3.44739 4.14846-3.23619 6.47176.20505 2.2555 1.81921 4.5563 4.65049 7.3875zm-1.1313 1.1313c2.8312 2.8313 5.132 4.4454 7.3875 4.6505 2.3232.2112 4.3203-1.0848 6.4718-3.2363l-1.1314-1.1313c-2.0912 2.0911-3.6297 2.9165-5.1955 2.7741-1.6336-.1485-3.5755-1.3627-6.4011-4.1883z"
        fill="#247cfe"
        className="fill-primary"
      />
    </svg>
  );
}

export function Email() {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.7155 13.3578C19.9131 12.9626 19.753 12.482 19.3578 12.2845C18.9626 12.0869 18.482 12.247 18.2845 12.6422L19.7155 13.3578ZM19.3002 24.16C19.7097 23.9943 19.9073 23.5279 19.7416 23.1183C19.5758 22.7088 19.1094 22.5112 18.6998 22.6769L19.3002 24.16ZM16 23.2C12.0235 23.2 8.8 19.9764 8.8 16H7.2C7.2 20.8601 11.1399 24.8 16 24.8V23.2ZM8.8 16C8.8 12.0235 12.0235 8.8 16 8.8V7.2C11.1399 7.2 7.2 11.1399 7.2 16H8.8ZM16 8.8C19.9764 8.8 23.2 12.0235 23.2 16H24.8C24.8 11.1399 20.8601 7.2 16 7.2V8.8ZM17.7 16C17.7 17.215 16.715 18.2 15.5 18.2V19.8C17.5987 19.8 19.3 18.0987 19.3 16H17.7ZM15.5 18.2C14.285 18.2 13.3 17.215 13.3 16H11.7C11.7 18.0987 13.4013 19.8 15.5 19.8V18.2ZM13.3 16C13.3 14.785 14.285 13.8 15.5 13.8V12.2C13.4013 12.2 11.7 13.9013 11.7 16H13.3ZM15.5 13.8C16.715 13.8 17.7 14.785 17.7 16H19.3C19.3 13.9013 17.5987 12.2 15.5 12.2V13.8ZM19 13C18.2845 12.6422 18.2843 12.6425 18.2842 12.6428C18.2841 12.6429 18.284 12.6432 18.2839 12.6434C18.2837 12.6438 18.2835 12.6442 18.2833 12.6447C18.2828 12.6455 18.2824 12.6465 18.2819 12.6475C18.2809 12.6494 18.2798 12.6517 18.2786 12.6542C18.2762 12.6592 18.2733 12.6652 18.27 12.6722C18.2635 12.6862 18.2552 12.7042 18.2456 12.7262C18.2263 12.7703 18.2014 12.8304 18.1728 12.9066C18.1157 13.059 18.044 13.2755 17.9739 13.556C17.8335 14.1175 17.7 14.9326 17.7 16H19.3C19.3 15.0674 19.4165 14.3825 19.5261 13.944C19.581 13.7245 19.6343 13.566 19.6709 13.4684C19.6892 13.4196 19.7034 13.386 19.7114 13.3675C19.7155 13.3583 19.718 13.3529 19.7188 13.3513C19.7191 13.3505 19.7191 13.3506 19.7186 13.3517C19.7183 13.3522 19.7179 13.353 19.7174 13.354C19.7172 13.3545 19.7169 13.3551 19.7166 13.3557C19.7164 13.356 19.7162 13.3564 19.7161 13.3567C19.716 13.3569 19.7159 13.3571 19.7158 13.3572C19.7157 13.3575 19.7155 13.3578 19 13ZM17.7 16C17.7 17.194 18.116 18.1587 18.8025 18.8243C19.4795 19.4808 20.3722 19.8 21.25 19.8C22.1278 19.8 23.0205 19.4808 23.6975 18.8243C24.384 18.1587 24.8 17.194 24.8 16H23.2C23.2 16.806 22.9285 17.3413 22.5837 17.6757C22.2295 18.0192 21.7472 18.2 21.25 18.2C20.7528 18.2 20.2705 18.0192 19.9163 17.6757C19.5715 17.3413 19.3 16.806 19.3 16H17.7ZM18.6998 22.6769C17.8671 23.014 16.9563 23.2 16 23.2V24.8C17.1655 24.8 18.28 24.573 19.3002 24.16L18.6998 22.6769Z"
        fill="#247CFE"
        className="fill-primary"
      />
    </svg>
  );
}

// Небольшая пасхалочка
function getCoord(percent) {
  const x = Math.cos(2 * Math.PI * percent);
  const y = Math.sin(2 * Math.PI * percent);

  return { x, y };
}

export function Clock({ className }) {
  const [time, setTime] = useState(new Date());

  const { x: xH, y: yH } = getCoord((time.getHours() % 12) / 12);
  const { x: xM, y: yM } = getCoord(time.getMinutes() / 60);

  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 9.933 1.7835 11.683 3.05025 12.9497C4.317 14.2165 6.067 15 8 15Z"
        stroke="#8A8C8F"
        className={className}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d={`M8 8L${8 + yH * 3} ${8 - xH * 3}`} stroke="#8A8C8F" strokeWidth="1.6" strokeLinecap="round" className={className} />
      <path d={`M8 8L${8 + yM * 4} ${8 - xM * 4}`} stroke="#8A8C8F" strokeWidth="1.6" strokeLinecap="round" className={className} />
    </svg>
  );
}

export function Location() {
  return (
    <svg viewBox="0 0 90 90" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M 45 90 c -1.062 0 -2.043 -0.561 -2.583 -1.475 l -4.471 -7.563 c -9.222 -15.591 -17.933 -30.317 -20.893 -36.258 c -2.086 -4.277 -3.138 -8.852 -3.138 -13.62 C 13.916 13.944 27.86 0 45 0 c 17.141 0 31.085 13.944 31.085 31.084 c 0 4.764 -1.051 9.339 -3.124 13.596 c -0.021 0.042 -0.042 0.083 -0.063 0.124 c -3.007 6.005 -11.672 20.654 -20.843 36.159 l -4.472 7.563 C 47.044 89.439 46.062 90 45 90 z M 45 6 C 31.168 6 19.916 17.253 19.916 31.084 c 0 3.848 0.847 7.539 2.518 10.969 c 2.852 5.721 11.909 21.033 20.667 35.839 L 45 81.104 l 1.89 -3.196 c 8.763 -14.813 17.823 -30.131 20.687 -35.879 c 0.012 -0.022 0.023 -0.045 0.035 -0.067 c 1.642 -3.406 2.474 -7.065 2.474 -10.877 C 70.085 17.253 58.832 6 45 6 z"
      />
      <path
        d="M 45 44.597 c -8.076 0 -14.646 -6.57 -14.646 -14.646 S 36.924 15.306 45 15.306 c 8.075 0 14.646 6.57 14.646 14.646 S 53.075 44.597 45 44.597 z M 45 21.306 c -4.767 0 -8.646 3.878 -8.646 8.646 s 3.878 8.646 8.646 8.646 c 4.768 0 8.646 -3.878 8.646 -8.646 S 49.768 21.306 45 21.306 z"
      />
    </svg>
  );
}

export function PosterHeart() {
  return (
    <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.90748 4.64455C7.43725 6.53283 5.30662 7.62794 3.14858 7.09054C2.92964 7.03602 2.71882 6.96679 2.51723 6.88443L0.017716 7.88423L0.883078 5.72086C0.152854 4.87336 -0.175124 3.77326 0.0925256 2.69846C0.562752 0.810176 2.69338 -0.284935 4.85142 0.252464C7.00946 0.789861 8.3777 2.75626 7.90748 4.64455ZM3.93846 2.44952L4.12665 3.21567L4.8928 3.02748C5.31594 2.92355 5.74321 3.18231 5.84714 3.60545C5.95108 4.02858 5.69231 4.45586 5.26918 4.55979L2.97072 5.12435L2.40615 2.82589C2.30222 2.40276 2.56098 1.97549 2.98412 1.87155C3.40725 1.76762 3.83453 2.02638 3.93846 2.44952Z"
        fill="#FF5B5B"
      />
    </svg>
  );
}

export function WarningSign() {
  return (
    <svg className="dish-valid-error" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM6.5505 3.70702C6.52321 3.32497 6.8258 3 7.20882 3H8.79118C9.1742 3 9.47679 3.32497 9.4495 3.70702L9.06634 9.07125C9.02896 9.59455 8.59352 10 8.06888 10H7.93112C7.40648 10 6.97104 9.59455 6.93366 9.07125L6.5505 3.70702ZM7.6 11C7.26863 11 7 11.2686 7 11.6V12.4C7 12.7314 7.26863 13 7.6 13H8.4C8.73137 13 9 12.7314 9 12.4V11.6C9 11.2686 8.73137 11 8.4 11H7.6Z"
        fill="#EEA619"
      />
    </svg>
  );
}

export function OkSign() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM11.1049 6.6687C11.4217 6.21625 11.3116 5.59272 10.8592 5.27601C10.4067 4.95929 9.7832 5.06933 9.46648 5.52178L7.33431 8.56773L6.22878 7.90441C5.7552 7.62026 5.14094 7.77383 4.85679 8.24741C4.57264 8.72099 4.72621 9.33525 5.19979 9.6194L7.10455 10.7623C7.55476 11.0324 8.1372 10.9083 8.43828 10.4782L11.1049 6.6687Z"
        fill="#6AAE74"
      />
    </svg>
  );
}

export function Forward() {
  return (
    <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1 10.5L5.5 6L1 1.5"
        stroke="#247CFE"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="stroke-primary"
      />
    </svg>
  );
}

export function IconChevronDown() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6 9L12 15L18 9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function Address() {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.8 14C10.8 11.1281 13.1281 8.80001 16 8.80001C18.8719 8.80001 21.2 11.1281 21.2 14C21.2 14.6283 20.9018 15.5247 20.3512 16.5944C19.8139 17.6382 19.0888 18.7489 18.3505 19.7756C17.6143 20.7993 16.8764 21.7237 16.3216 22.393C16.2057 22.5328 16.0979 22.6613 16 22.7771C15.9021 22.6613 15.7943 22.5328 15.6784 22.393C15.1237 21.7237 14.3857 20.7993 13.6495 19.7756C12.9112 18.7489 12.1861 17.6382 11.6488 16.5944C11.0982 15.5247 10.8 14.6283 10.8 14ZM15.4044 24.5341C15.4045 24.5342 15.4046 24.5343 16 24L15.4046 24.5343C15.5563 24.7034 15.7728 24.8 16 24.8C16.2272 24.8 16.4437 24.7034 16.5954 24.5343L16 24C16.5954 24.5343 16.5955 24.5342 16.5956 24.5341L16.596 24.5337L16.597 24.5325L16.6008 24.5283L16.6147 24.5127L16.6671 24.4536C16.7126 24.4021 16.7787 24.3268 16.8624 24.2302C17.0298 24.037 17.268 23.7584 17.5534 23.414C18.1237 22.7261 18.8857 21.7718 19.6495 20.7097C20.4112 19.6506 21.1861 18.4684 21.7738 17.3266C22.3482 16.2106 22.8 15.0286 22.8 14C22.8 10.2445 19.7555 7.20001 16 7.20001C12.2445 7.20001 9.20001 10.2445 9.20001 14C9.20001 15.0286 9.65179 16.2106 10.2262 17.3266C10.8139 18.4684 11.5888 19.6506 12.3505 20.7097C13.1143 21.7718 13.8764 22.7261 14.4466 23.414C14.732 23.7584 14.9703 24.037 15.1377 24.2302C15.2214 24.3268 15.2874 24.4021 15.3329 24.4536L15.3853 24.5127L15.3992 24.5283L15.403 24.5325L15.4041 24.5337L15.4044 24.5341ZM14.8 14C14.8 13.3373 15.3373 12.8 16 12.8C16.6628 12.8 17.2 13.3373 17.2 14C17.2 14.6628 16.6628 15.2 16 15.2C15.3373 15.2 14.8 14.6628 14.8 14ZM16 11.2C14.4536 11.2 13.2 12.4536 13.2 14C13.2 15.5464 14.4536 16.8 16 16.8C17.5464 16.8 18.8 15.5464 18.8 14C18.8 12.4536 17.5464 11.2 16 11.2Z"
        fill="#247CFE"
        className="fill-primary"
      />
    </svg>
  );
}

export function CrossIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      className="bi bi-x d-inline"
      viewBox="0 0 16 16"
    >
      <path
        d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647
                                    2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0
                                    1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"
      />
    </svg>
  );
}

export function TagStarIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" fill="none">
      <mask id="a" width="13" height="13" x=".501" y="1.034" fill="#000" maskUnits="userSpaceOnUse">
        <path fill="#fff" d="M.501 1.034h13v13h-13z" />
        <path d="M6.581 2.514c.135-.272.202-.408.293-.452a.292.292 0 0 1 .251 0c.092.044.159.18.293.452L8.694 5.1c.04.08.06.12.088.151.026.028.057.05.091.066.039.018.083.025.172.038l2.853.417c.3.044.45.066.52.14.06.063.09.15.078.238-.014.1-.122.206-.34.418l-2.064 2.01c-.064.063-.096.094-.117.131a.292.292 0 0 0-.035.107.637.637 0 0 0 .018.175l.487 2.84c.051.299.077.449.029.538a.292.292 0 0 1-.203.147c-.1.019-.234-.052-.503-.194l-2.55-1.341c-.08-.042-.12-.063-.162-.07a.294.294 0 0 0-.112 0c-.042.007-.082.028-.161.07l-2.551 1.341c-.269.142-.404.213-.503.194a.292.292 0 0 1-.203-.147c-.048-.09-.023-.239.029-.539l.487-2.839a.638.638 0 0 0 .017-.175.291.291 0 0 0-.034-.107c-.021-.037-.053-.068-.118-.13L1.843 6.566c-.217-.212-.326-.318-.339-.418a.292.292 0 0 1 .077-.239c.07-.073.22-.095.52-.14l2.854-.416c.089-.013.133-.02.172-.038a.292.292 0 0 0 .09-.066.638.638 0 0 0 .089-.151L6.58 2.514Z" />
      </mask>
      <path
        fill="#FFD645"
        d="M6.581 2.514c.135-.272.202-.408.293-.452a.292.292 0 0 1 .251 0c.092.044.159.18.293.452L8.694 5.1c.04.08.06.12.088.151.026.028.057.05.091.066.039.018.083.025.172.038l2.853.417c.3.044.45.066.52.14.06.063.09.15.078.238-.014.1-.122.206-.34.418l-2.064 2.01c-.064.063-.096.094-.117.131a.292.292 0 0 0-.035.107.637.637 0 0 0 .018.175l.487 2.84c.051.299.077.449.029.538a.292.292 0 0 1-.203.147c-.1.019-.234-.052-.503-.194l-2.55-1.341c-.08-.042-.12-.063-.162-.07a.294.294 0 0 0-.112 0c-.042.007-.082.028-.161.07l-2.551 1.341c-.269.142-.404.213-.503.194a.292.292 0 0 1-.203-.147c-.048-.09-.023-.239.029-.539l.487-2.839a.638.638 0 0 0 .017-.175.291.291 0 0 0-.034-.107c-.021-.037-.053-.068-.118-.13L1.843 6.566c-.217-.212-.326-.318-.339-.418a.292.292 0 0 1 .077-.239c.07-.073.22-.095.52-.14l2.854-.416c.089-.013.133-.02.172-.038a.292.292 0 0 0 .09-.066.638.638 0 0 0 .089-.151L6.58 2.514Z"
      />
      <path
        fill="#F1C836"
        d="m4.955 5.354.144.99-.144-.99Zm.172-.038-.422-.906.422.906Zm.179-.217-.897-.443.897.443Zm-.089.151.733.681-.733-.68ZM1.844 6.567l-.698.716.698-.716Zm-.34-.418.991-.131-.991.13Zm.598-.378-.145-.99.145.99Zm-.52.14-.727-.689.726.688Zm2.46 3.08-.986-.17.986.17Zm.017-.176.993-.12-.993.12Zm-.152-.238.698-.716-.698.716Zm.118.131.873-.486-.873.486Zm.207 3.614.465.885-.465-.886Zm-.503.193-.182.983.182-.983Zm-.174-.686.985.17-.985-.17Zm-.03.539-.878.477.879-.477Zm3.692-1.388-.465.885.465-.885Zm-.161-.07.192-.982-.192.981Zm-.273.07-.466-.885.466.885Zm.16-.07.193.98-.192-.98Zm3.502.92.986-.17-.986.17Zm.029.538-.879-.478.879.478Zm-.706-.046.465-.886-.465.886Zm.503.193-.183-.983.183.983Zm-.179-3.938.698.716-.698-.716Zm-.117.131.874.487-.874-.487Zm-.017.282-.986.17.986-.17Zm-.018-.175-.992-.12.992.12Zm1.958-3.044.145-.99-.145.99Zm.52.14.726-.689-.726.688Zm-.262.656-.697-.716.697.716Zm.34-.418-.992-.131.992.13Zm-3.802-1.05.897-.443-.897.443Zm.088.151-.732.681.732-.68Zm.263.104-.145.99.145-.99Zm-.172-.038.422-.906-.422.906ZM7.418 2.514l-.896.443.896-.443Zm-.293-.452.43-.902-.43.902Zm-.544.452.897.443-.897-.443Zm.293-.452-.43-.902.43.902Zm-.352.895 1.275 2.584 1.794-.885-1.276-2.584-1.793.885ZM8.9 6.343l2.854.417.289-1.979-2.854-.417-.289 1.98Zm2.559-.492L9.395 7.86l1.395 1.432 2.064-2.01-1.395-1.432ZM8.972 9.159 9.46 12l1.972-.338-.487-2.84-1.972.338Zm1.261 2.277-2.55-1.341-.931 1.77 2.55 1.341.931-1.77Zm-3.916-1.341-2.55 1.341.93 1.77 2.551-1.34-.93-1.771ZM4.54 11.999l.487-2.84-1.97-.338-.488 2.84 1.971.338Zm.065-4.138L2.541 5.85 1.146 7.283l2.064 2.01 1.395-1.432Zm-2.359-1.1L5.1 6.342 4.81 4.364l-2.853.417.29 1.98Zm3.957-1.22 1.275-2.584-1.793-.885-1.276 2.584 1.794.885Zm-1.104.802c.029-.004.247-.026.45-.12L4.704 4.41a.718.718 0 0 1 .155-.053c.008-.002.009-.002-.002 0a4.69 4.69 0 0 1-.048.007l.29 1.98Zm-.69-1.687-.021.043-.001.002a.719.719 0 0 1 .098-.131L5.95 5.93c.152-.163.24-.364.253-.39l-1.794-.885Zm1.14 1.567c.15-.07.287-.17.4-.292L4.486 4.57a.708.708 0 0 1 .22-.16l.843 1.813ZM2.54 5.851a11.693 11.693 0 0 1-.184-.185c-.006-.007.017.019.045.068.031.055.076.152.093.284L.513 6.28c.046.352.242.59.324.686.093.108.214.225.309.317L2.54 5.851Zm-.584-1.07c-.13.02-.297.043-.436.076-.123.03-.421.108-.666.365l1.452 1.376a.788.788 0 0 1-.241.175c-.052.024-.086.03-.077.029a11.785 11.785 0 0 1 .258-.041l-.29-1.98Zm.538 1.237a.708.708 0 0 1-.188.58L.855 5.222A1.292 1.292 0 0 0 .513 6.28l1.982-.262Zm2.532 3.141c.005-.028.052-.242.025-.464l-1.985.24a.719.719 0 0 1-.002-.164v.002l-.009.048 1.971.338Zm-1.817.134.034.034.002.002a.719.719 0 0 1-.095-.134l1.747-.973c-.108-.195-.272-.341-.293-.361L3.21 9.293Zm1.842-.598a1.292 1.292 0 0 0-.154-.473l-1.747.973a.708.708 0 0 1-.084-.26l1.985-.24Zm-1.286 2.741c-.069.037-.12.064-.163.085-.043.022-.063.031-.07.034-.007.003.024-.011.08-.022a.79.79 0 0 1 .298-.001l-.364 1.966c.349.065.636-.048.753-.096.132-.055.28-.134.397-.195l-.93-1.77Zm-1.197.225c-.022.13-.052.295-.063.438-.01.126-.028.434.141.746l1.758-.955a.788.788 0 0 1 .091.284c.007.057.003.091.004.083l.01-.077.03-.181-1.97-.338Zm1.342-.13c.21.04.392.172.494.36l-1.758.954c.186.342.517.582.9.653l.364-1.966Zm3.772-1.436c-.026-.013-.215-.124-.435-.167l-.384 1.962a.722.722 0 0 1-.157-.049 4.925 4.925 0 0 1 .045.024l.93-1.77Zm-.435 1.77.043-.022a.722.722 0 0 1-.155.048l-.385-1.963c-.219.043-.408.154-.434.167l.931 1.77Zm0-1.937a1.291 1.291 0 0 0-.497 0l.385 1.962a.71.71 0 0 1-.272 0l.384-1.962Zm2.211 2.07a11.737 11.737 0 0 1 .04.259c.002.008-.002-.026.004-.083a.788.788 0 0 1 .092-.284l1.757.955c.17-.312.152-.62.142-.746-.012-.143-.041-.308-.063-.438l-1.972.338Zm-.157 1.209c.117.061.266.14.398.195.116.048.404.161.753.096l-.365-1.966a.79.79 0 0 1 .299 0c.056.012.087.026.079.023a1.187 1.187 0 0 1-.07-.034c-.043-.021-.093-.048-.163-.085l-.93 1.77Zm.293-1.317a.709.709 0 0 1 .493-.358l.365 1.966c.383-.07.713-.31.9-.653l-1.758-.955Zm-.2-4.03c-.02.02-.185.167-.294.362l1.748.973a.72.72 0 0 1-.095.134c-.005.005-.006.006.001-.002l.035-.034-1.395-1.432Zm1.549.961-.009-.048v-.002a.717.717 0 0 1-.002.164l-1.985-.24c-.027.222.02.436.024.464l1.972-.338Zm-1.843-.6a1.292 1.292 0 0 0-.153.474l1.985.24a.708.708 0 0 1-.084.26L9.1 8.222Zm2.652-1.46c.078.01.135.019.182.027l.076.014c.009.002-.025-.005-.077-.03a.789.789 0 0 1-.242-.174l1.452-1.376a1.323 1.323 0 0 0-.665-.365c-.14-.033-.306-.057-.436-.076l-.29 1.98Zm1.1.522c.095-.092.217-.209.31-.317.082-.096.278-.334.324-.686l-1.983-.262a.788.788 0 0 1 .093-.284c.028-.05.051-.075.046-.068a1.24 1.24 0 0 1-.054.056l-.13.129 1.395 1.432Zm-1.16-.685a.709.709 0 0 1-.189-.58l1.983.262a1.292 1.292 0 0 0-.343-1.058l-1.452 1.376ZM7.796 5.54c.013.026.1.227.253.39L9.515 4.57c.058.062.09.116.098.131.004.007.004.008 0-.002a4.687 4.687 0 0 1-.022-.043l-1.794.885ZM9.19 4.364a4.633 4.633 0 0 1-.048-.007c-.01-.002-.009-.002-.002 0a.718.718 0 0 1 .156.053L8.45 6.223c.203.094.42.116.45.12l.288-1.979ZM8.05 5.931c.115.122.25.222.402.292l.844-1.813a.708.708 0 0 1 .22.16L8.05 5.93Zm.266-3.86c-.058-.118-.132-.269-.207-.39a1.324 1.324 0 0 0-.552-.521l-.861 1.805a.788.788 0 0 1-.241-.176c-.039-.042-.056-.072-.051-.064l.037.068.082.164 1.793-.885Zm-.837.886a11.682 11.682 0 0 1 .119-.232c.004-.008-.012.022-.051.064a.788.788 0 0 1-.241.176L6.444 1.16c-.32.152-.487.413-.553.52-.074.122-.148.273-.206.392l1.793.885Zm.078-1.797a1.292 1.292 0 0 0-1.112 0l.86 1.805a.708.708 0 0 1-.609 0l.86-1.805Z"
        mask="url(#a)"
      />
    </svg>
  );
}

export function TagPlusIcon() {
  return (
    <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.99984 3.41675V11.5834M2.9165 7.50008H11.0832"
        stroke="#22A4D9"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function HeaderMenuIcon(props) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M3 12H21M3 6H21M3 18H21"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function HeaderSearchIcon(props) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M21 21L15.0001 15M17 10C17 13.866 13.866 17 10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function HeaderSearhClearIcon(props) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M17 15L11 9M11 15L17 9M2.72 11.04L7.04 5.28C7.392 4.81067 7.568 4.576 7.79105 4.40675C7.9886 4.25685 8.21232 4.14499 8.45077 4.07689C8.72 4 9.01334 4 9.6 4L17.2 4C18.8802 4 19.7202 4 20.362 4.32698C20.9265 4.6146 21.3854 5.07354 21.673 5.63803C22 6.27976 22 7.11984 22 8.8L22 15.2C22 16.8802 22 17.7202 21.673 18.362C21.3854 18.9265 20.9265 19.3854 20.362 19.673C19.7202 20 18.8802 20 17.2 20L9.6 20C9.01334 20 8.72 20 8.45077 19.9231C8.21232 19.855 7.9886 19.7432 7.79105 19.5932C7.568 19.424 7.392 19.1893 7.04 18.72L2.72 12.96C2.46181 12.6157 2.33271 12.4436 2.28294 12.2546C2.23902 12.0877 2.23902 11.9123 2.28294 11.7454C2.33271 11.5564 2.46181 11.3843 2.72 11.04Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function HeaderArrowLeftIcon(props) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M20 12L4 12M4 12L10 6M4 12L10 18"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SidebarCloseIcon(props) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
